module.exports = __webpack_public_path__ + "img/signin_image.668f59cc.png";